import clsx from 'clsx';

interface IGridwallDetailProps {
    cameraIndex: number;
}

const GridwallCardShadow = (props: IGridwallDetailProps) => {
    const { cameraIndex } = props;

    return (
        <div className={clsx('relative w-full h-full bg-grayscale-500  overflow-hidden aspect-video')}>
            <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-white text-xs opacity-50" />
            </div>

            <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 px-4 py-1">
                <div className="text-white text-xs text-center truncate">Camera - {cameraIndex + 1}</div>
            </div>
        </div>
    );
};

export default GridwallCardShadow;
